<template>
  <div>
    <div class="userPage">
    <div class="userTop">
      <h2>第二十届中国国际石油石化技术装备展览会</h2>
    </div>
    <div class="card">
      <div class="cardT1">
        <div>
          <img :src="user.img" alt="" />
        </div>
        <div>
          <h3>{{user.name?user.name:user.nickname}}</h3>
          <p>{{user.duties?user.duties:""}}</p>
        </div>
      </div>
      <p><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/dianhua.png" alt="" />{{user.mobile?user.mobile:user.phone}}</p>
      <p><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/dizhi.png" alt="" />****有限公司</p>
      <p><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/dianhua.png" alt="" />{{user.mobile?user.mobile:user.phone}}</p>
      <p><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/youxiang.png" alt="" />{{user.email?user.email:"暂无"}}</p>
      <!-- <i class="iconfont icon-bianji"></i> -->
      <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/bianji.png" alt="" />
    </div>
    <!-- 我的收藏 -->
    <div class="userList collection">
      <h4><span></span> 我的收藏</h4>
      <ul>
        <li v-for="(item,index) in collect" :key="'sc'+index" @click="()=>$router.push(item.url)">
          <img :src="item.img_url" alt="" />
          {{item.title}}
        </li>
      </ul>
    </div>
    <!-- 展会相关 -->
    <div class="userList related">
      <h4><span></span> 展会相关</h4>
      <ul>
        <li @click="appHerf('https://www.cippe.com.cn/cn/aboutus/introduce')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanhuigaikuang.png" alt="" />
          展会概况
        </li>
        <li >
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanqianyulan.png" alt="" />
          展前预览
        </li>
        <li @click="appHerf('https://www.cippe.com.cn/cn/visitors/guide')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/canguanzhinan.png" alt="" />
          参观指南
        </li>
        <li @click="appHerf('https://www.cippe.com.cn/cn/businesstravel/hotel')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/jiudianyuding.png" alt="" />
          酒店预订
        </li>
        <li @click="appHerf('http://www.cippe.com.cn/cn/businesstravel/traffic')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/jiaotongditu.png" alt="" />
          交通地图
        </li>
        <li @click="appHerf('https://www.cippe.com.cn/cn/exhibitors/build/')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/dajian.png" alt="" />
          指定搭建
        </li>
        <li @click="appHerf('https://www.cippe.com.cn/cn/exhibitors/transport')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/yunshu.png" alt="" />
          运输服务
        </li>
      </ul>
    </div>
    <!-- 联系热线 -->
    <ul class="hotline">
      <a href="tel:010-56176968">
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/canzhan.png" alt="" />
          <p>
            <span>参展热线：</span><span class="colorPhone">010-56176968</span>
          </p>
        </li>
      </a>
      <a href="tel:010-56176941">
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/cangaun.png" alt="" />
          <p>
            <span>参观热线：</span><span class="colorPhone">010-56176941</span>
          </p>
        </li>
      </a>
      <a href="tel:010-50917095">
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/rexian.png" alt="" />
          <p>
            <span>技术热线：</span><span class="colorPhone">010-50917095</span>
          </p>
        </li>
      </a>
      <a href="tel:010-50917091">
        <li>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/rexian.png" alt="" />
          <p>
            <span>媒体合作：</span><span class="colorPhone">010-50917091</span>
          </p>
        </li>
      </a>
    </ul>
  </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components:{

  },
  data () {
    return {
      selected:"1",
      collect:[
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanshangshoucang.png",
          url:"/userapp/merchantsCollection",
          title:"展商收藏",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanpinshoucang.png",
          url:"/userapp/goodsCollection",
          title:"展品收藏",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/yiyuezhanshang.png",
          url:"/userapp/aboutGoods",
          title:"已约展商",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/guanzhongyaoqing.png",
          url:"/userapp/aboutAudience",
          title:"观众邀约",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/caigou.png",
          url:"/userapp/purchaseManagement",
          title:"采购管理",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/gongying.png",
          url:"/userapp/supplyManagement",
          title:"供应管理",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/pinglun.png",
          url:"/user/comments",
          title:"我的评论",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/xunpan.png",
          url:"/user/consulting",
          title:"询盘咨询",
        }
      ],
      
    }
  },
  mounted () {

  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
      isLogin:state=>state.user.isLogin,
    })
  },
}
</script>

<style scoped>
  .userTop{
    margin-left: -10px;
    margin-right: -10px;
    height: 200px;
    background-color: #008baf;
    color: white;
    padding: 15px 10px;
    box-sizing: border-box;
  }
  .userTop h2{
    font-size: 13px;
  }
  .card{
    position: relative;
    margin-top: -150px;
    width: 100%;
    /* height: 500px; */
    padding: 15px 25px;
    border-radius: 10px;
    background-color: white;
    overflow: hidden;
    box-shadow: 2px 2px 10px rgba(255, 255, 255, 1);
    margin-bottom: 40px;
  }
  .cardT1{
    /* height: 200px; */
    display: flex;
    padding-bottom:15px ;
    border-bottom: 1px solid #e5e5e5;
  }
  .cardT1 div:first-child{
    width: 70px;
    height: 70px;
    border-radius: 50%;
    overflow: hidden;
    vertical-align: middle;
  }
  .cardT1 div:nth-child(2){
    margin-left: 15PX;
    margin-top: 10px;
  }
  .cardT1 h3{
    font-size: 18px;
    font-weight: 600;
    /* margin-bottom: 10px; */
  }
  .card p{
    margin-top: 10px;
  }
  .card p img{
    margin-right: 8px;
    color: #808080;
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }
  .card > img{
    position: absolute;
    right: 10px;
    top: 10px;
    /* color: #808080; */
    width: 40px;
    height: 40px;
  }

  .userList{
    margin-left: -10px;
    margin-right: -10px;
    margin-bottom: 30px;
    background-color: white;
    padding: 10px;

  }
  .userList h4{
    font-size: 16px;
    color: #008baf;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .userList span{
    display:inline-block;
    height:16px;
    width: 4px;
    background-color: #008baf;
    margin-right: 5px;
    vertical-align: middle;
  }
  .userList ul{
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-around; */
    text-align: center;
  }
  .userList li{
    width: 23%;
    margin-left: 1.6%;
    margin-bottom: 15px;
    text-align: center;
  }
  .userList li img{
    display: block;
    font-size: 30px;
    /* margin-bottom: 5px; */
    /* width: 40px; */
    height: 40px;
  }
  .hotline{
    background-color: white;
    margin-left: -10px;
    margin-right: -10px;
    padding: 10px 0 10px 10px;
  }
  .hotline li{
    display: flex;
    align-items: center;
  }
  .hotline li img{
    font-size: 18px;
    width: 30px;
  }
  .hotline li p{
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    width: calc(100vw - 40px);
  }
</style>